/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Erp_File_SettledInputs */

const en_error_erp_file_settled = /** @type {(inputs: Error_Erp_File_SettledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The import of this file already has an outcome.`)
};

/**
* | output |
* | --- |
* | "The import of this file already has an outcome." |
*
* @param {Error_Erp_File_SettledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_erp_file_settled = /** @type {((inputs?: Error_Erp_File_SettledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Erp_File_SettledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_erp_file_settled(inputs)
});